export default function Footer() {
  return (
    <footer>
      <p>Truco Acessível © 2026 — Frontend acessível para deficientes visuais</p>
    </footer>
  )
}
